/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Unarchive_ProductInputs */

const en_lifecycle_unarchive_product = /** @type {(inputs: Lifecycle_Unarchive_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive product`)
};

const de_lifecycle_unarchive_product = /** @type {(inputs: Lifecycle_Unarchive_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt aus dem Archiv holen`)
};

/**
* | output |
* | --- |
* | "Unarchive product" |
*
* @param {Lifecycle_Unarchive_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_unarchive_product = /** @type {((inputs?: Lifecycle_Unarchive_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Unarchive_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_unarchive_product(inputs)
	return en_lifecycle_unarchive_product(inputs)
});